import { render, staticRenderFns } from "./page.vue?vue&type=template&id=a064e39a&"
import script from "./_page.js?vue&type=script&lang=js&"
export * from "./_page.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports